<template>
  <div>
    <Hero title="Über uns" />
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('Über uns') }}
        </div>
      </div>

      <h2>{{ $t('Was ist Lernpfad und wer steckt dahinter?') }}</h2>
      <p>
        {{
          $t(
            'Für Lehrpersonen, welche im Unterricht Lehr- und Lernmaterialien aus unterschiedlichen Quellen benützen, ist es eine Herausforderung dem Lernprozess Struktur zu geben und den individuellen Arbeitsstand der Lernenden zu überblicken.'
          )
        }}
      </p>

      <p>
        {{
          $t(
            'Mit Lernpfad bieten wir Lehrpersonen eine Plattform, mit welcher Unterrichtsszenarien medien- und quellenübergreifend abgebildet werden können. Ein Lernpfad besteht dabei aus einem Ziel und beliebig vielen Lernschritten und kann mit Lernenden geteilt werden.'
          )
        }}
      </p>

      <p>
        {{
          $t(
            'Hinter dem Projekt Lernpfad.ch stehen folgende Personen als Co-Creator*innen'
          )
        }}
      </p>

      <team-list>
        <team-member
          name="Marc Widmer"
          :description="
            $t(
              'Lernen fasziniert mich und ich möchte verstehen, wie ich Lehrende und Lernende dabei unterstützen kann.'
            ) +
            ' ' +
            $t(
              'Bei Lernpfad bin ich für die Ideen verantwortlich, seien das nun solche von Nutzenden oder unsere eigenen.'
            )
          "
          img="/static/images/team/MarcWidmer.png"
        />
        <team-member
          name="Pawel Kowalski"
          :description="
            $t(
              'Meine Leidenschaft ist die Entwicklung digitaler Produkte wie Lernpfad.'
            ) +
            ' ' +
            $t(
              'In das Lernpfad Projekt bringe ich meine Erfahrung als Software Engineer und Produktdesigner ein.'
            ) +
            ' ' +
            $t(
              'Es macht mir Riesenspass mit unserem interdisziplinären Team den Lernpfad zu entwickeln.'
            )
          "
          img="/static/images/team/PawelKowalski.png"
        />
        <team-member
          name="Andreas Hieber"
          :description="
            $t(
              'Ich bin fasziniert von digitalen Produkten, die dazu beitragen Probleme oder Herausforderungen von Bildungsakteuren (Lehrpersonen, Dozierende, Schülerinnen, Studierende) intelligent zu lösen.'
            ) +
            ' ' +
            $t(
              'Bei Lernpfad bin ich für die Geschäftsentwicklung und die Vernetzung zuständig.'
            )
          "
          img="/static/images/team/AndreasHieber.png"
        />
        <team-member
          name="Marcel Eyer"
          :description="
            $t('Lernen ist ein zentraler Bestandteil unseres Leben.') +
            ' ' +
            $t(
              'Ich liebe es neue Ideen auszuprobieren und in einem motivierten Team zu arbeiten und zu lernen.'
            ) +
            ' ' +
            $t('Bei Lernpfad bin ich Teil des Software Teams.')
          "
          img="/static/images/team/MarcelEyer.png"
        />
        <team-member
          name="Manuela Bonetti"
          :description="
            $t(
              'Ein digitales Produkt soll nicht nur hübsch aussehen, sondern auch benutzerfreundlich sein und Spass machen.'
            ) +
            ' ' +
            $t(
              'Als UX-Designerin kümmere ich mich ums Design und die Anliegen der Benutzer, Auftraggeber und Entwickler.'
            )
          "
          img="/static/images/team/ManuelaBonetti.png"
        />
        <team-member
          name="Erich Buri"
          :description="
            $t(
              'In einem interdisziplinären, motivierten Team ein sinnvolles Produkt zu entwickeln macht riesen Spass!'
            ) +
            ' ' +
            $t(
              'Die Zufriedenheit der Benutzer steht für mich im Vordergrund.'
            ) +
            ' ' +
            $t(
              'Als Teil des Software-Teams kümmere ich mich um kleine und grössere Verbesserungen.'
            )
          "
          img="/static/images/team/ErichBuri.png"
        />
        <team-member
          name="Angélique Hameau"
          :description="
            $t(
              'Ich habe viel Freude an der Entwicklung digitaler Plattformen wie Lernpfad. Als Teil des Software-Teams von Lernpfad optimiere ich die Webapplikation und programmiere neue Funktionen.'
            )
          "
          img="/static/images/team/AngeliqueHameau.jpg"
        />
      </team-list>
    </section>
  </div>
</template>

<script>
import Hero from '../components/ui/Hero'
import TeamMember from '../components/ui/TeamMember'
import TeamList from '../components/ui/TeamList'
import { ampli } from '../mixins/Amplitude/index.js'

export default {
  components: {
    Hero,
    TeamMember,
    TeamList,
  },

  mixins: [ampli],

  scrollToTop: true,

  head() {
    return {
      title: this.$i18n.t('Über uns | Lernpfad'),
    }
  },
  created() {
    ampli.teamPageViewed()
  },
}
</script>

<style
  scoped
  lang="scss"
>
@import '../assets/style/utils';

h1 {
  word-wrap: break-word;
}

h2 {
  margin: 2rem 0 1rem 0;
  @include fontSizeLineHeight(35px, 66px);
}

p {
  margin-bottom: 1rem;
}

.content {
  margin-top: 5em;
}
</style>
